import { createContext } from "react";

const GoogleMapsApiContext = createContext();

export default GoogleMapsApiContext;
